module.exports = __webpack_public_path__ + "static/invite.3656d069.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ThePlatform/invite.png
// module id = 459
// module chunks = 145206920446059